import { styled } from "@mui/material/styles";

const RouteStepMain = styled("div")(({ theme }) => ({
  marginTop: "35px",
  paddingBottom: "40px",
  [theme.breakpoints.down("md")]: {
    paddingBottom: "30px",
  },
}));
const InputFlexWrap = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  marginBottom: "5px",
  gap: "20px",
  flexDirection: "row",
  "& .AuthInputMain": { width: "100%" },
  [theme.breakpoints.down("md")]: {
    gap: "5px",
    flexDirection: "column",
    // "& .AuthInputMain": { paddingBottom: "15px" },
  },
}));

const CheckBoxMain = styled("div")(({ theme }) => ({
  width: "100%",
  "& h6": {
    fontStyle: "normal",
    fontWeight: 500,
    fontSize: "18px",
    lineHeight: "25px",
    color: "#0B0B0B",
    fontFamily: theme.typography.fontFamily,
  },
  "& .css-vqyynb-MuiFormLabel-root": {
    fontStyle: "normal",
    fontWeight: 500,
    fontSize: "18px",
    lineHeight: "25px",
    color: "#0B0B0B",
    fontFamily: theme.typography.fontFamily,
  },
  "& .css-1jmlkw2-MuiButtonBase-root-MuiRadio-root": {
    padding: "5px",
  },
  "& .css-1ae958b-MuiSvgIcon-root": {
    width: "15px",
    height: "15px",
    color: "#D0D0D0",
  },
  "& .css-1m7o2of-MuiSvgIcon-root": {
    width: "15px",
    height: "15px",
    color: "#D0D0D0",
  },
  "& .css-6oje6m-MuiSvgIcon-root": { width: "15px", height: "15px" },
  "& .css-j204z7-MuiFormControlLabel-root .MuiFormControlLabel-label": {
    fontStyle: "normal",
    fontWeight: 400,
    fontSize: "16px",
    lineHeight: "16px",
    color: "rgba(11, 11, 11, 0.5)",
    fontFamily: theme.typography.fontFamily,
  },
}));
const ErrorSpan = styled("span")(({ theme }) => ({
  color: "red",
  fontWeight: 400,
  fontSize: "14px",
  fontFamily: theme.typography.fontFamily,
  marginLeft: "9px",
}));

const ButtomWraper = styled("div")(({ theme }) => ({
  marginTop: "50px",
  display: "flex",
  gap: "20px",
  flexDirection: "row",
  [theme.breakpoints.down("md")]: {
    gap: "5px",
    flexDirection: "column-reverse",
    "& button:first-of-type": {
      marginTop: "10px",
    },
  },
}));

export { RouteStepMain, InputFlexWrap, CheckBoxMain, ErrorSpan, ButtomWraper };
